import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '../contexts/AuthContext';
import { useTeam } from '../pages/YourTeams/contexts/TeamContext';
import { fetchTeamMembers } from '../services/teamService';
import { User } from '../types/index';

export function useTeamMembers(): UseQueryResult<User[]> {
  const { team } = useTeam();
  const { userData: user } = useAuth();
  const teamMembers = team?.team_members || [];

  return useQuery({
    queryKey: ['teamMembers', team?.id],
    queryFn: () => fetchTeamMembers(teamMembers, user?.userType),
    enabled: !!team?.id && teamMembers.length > 0,
  });
}
